<template>
  <LayoutCard>
    <p>{{ title }}</p>
    <div class="common-insert" :class="{ 'column': column, 'center': center }">
      <slot />
    </div>
  </LayoutCard>
</template>

<script setup lang="ts">
import LayoutCard from '../layout/LayoutCard.vue'

defineProps<{
  title: string
  column?: boolean
  center?: boolean
}>()
</script>

<style scoped>
.common-insert {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
}

p {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 700;
}

.column {
  flex-direction: column;
  justify-content: center;
}

.center {
  align-items: center;
}
</style>
